import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { Send as A } from "lucide-react";
import { forwardRef as R } from "react";
import { A as z } from "./Avatar-ihLwDM5D.js";
import { C as L } from "./Checkbox-wOzf8suy.js";
import { I as P } from "./IconButton-D1bLZM6I.js";
import { L as I } from "./LeadStatusPill-DaWOFt-a.js";
import { P as O } from "./Pill-uAcQLotY.js";
const s = {
  padding: "var(--space-3) var(--space-3)",
  fontSize: "var(--text-xs)",
  color: "var(--text-secondary)",
  verticalAlign: "middle"
}, o = {
  checkbox: 36,
  lead: 260,
  company: 180,
  account: 110,
  business: 130,
  lastAction: 320,
  date: 80,
  action: 44
}, T = R(function({
  lead: e,
  selected: d = !1,
  active: p = !1,
  as: n = "tr",
  labels: l,
  onToggleSelect: m,
  onSelect: h,
  onSendToCrm: y,
  className: v,
  style: w,
  ...u
}, f) {
  const x = n === "tr" ? "tr" : "div", i = n === "tr" ? "td" : "div", a = n === "div" ? { role: "cell" } : {}, g = n === "div" ? { role: "row" } : {}, b = (r) => {
    r.target.closest("[data-ls-row-stop]") || h?.();
  }, k = (r) => {
    if (r.key === "Enter" || r.key === " ") {
      if (r.target.closest("[data-ls-row-stop]")) return;
      r.preventDefault(), h?.();
    }
  }, C = {
    cursor: "pointer",
    background: p ? "var(--bg-elevated)" : "transparent",
    color: "var(--text-primary)",
    borderBottom: "1px solid var(--border-subtle)",
    ...w
  };
  return /* @__PURE__ */ c(
    x,
    {
      ref: f,
      "data-ls-component": "lead-row",
      "data-selected": d ? "true" : void 0,
      "data-active": p ? "true" : void 0,
      "data-status": e.status,
      "data-source": e.source,
      "data-crm-sync": e.crmSync ? "true" : void 0,
      tabIndex: 0,
      onClick: b,
      onKeyDown: k,
      className: v,
      style: C,
      ...g,
      ...u,
      children: [
        /* @__PURE__ */ t(
          i,
          {
            ...a,
            style: { ...s, width: o.checkbox, paddingRight: 0 },
            "data-ls-row-stop": !0,
            onClick: (r) => r.stopPropagation(),
            children: /* @__PURE__ */ t(
              L,
              {
                "aria-label": l.checkbox,
                checked: d,
                onCheckedChange: (r) => m?.(r === !0),
                size: "sm"
              }
            )
          }
        ),
        /* @__PURE__ */ t(i, { ...a, style: { ...s, width: o.lead }, children: /* @__PURE__ */ c("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-3)" }, children: [
          /* @__PURE__ */ t(z, { size: "md", initials: e.initials, alt: e.name }),
          /* @__PURE__ */ c("div", { style: { minWidth: 0 }, children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  fontSize: "var(--text-sm)",
                  fontWeight: 600,
                  color: "var(--text-primary)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                },
                children: e.name
              }
            ),
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  fontSize: "var(--text-2xs)",
                  color: "var(--text-tertiary)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                },
                children: e.title
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ t(i, { ...a, style: { ...s, width: o.company }, children: /* @__PURE__ */ t(
          "span",
          {
            style: {
              display: "inline-block",
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "var(--text-primary)"
            },
            title: e.company,
            children: e.company
          }
        ) }),
        /* @__PURE__ */ t(i, { ...a, style: { ...s, width: o.account }, children: /* @__PURE__ */ t(
          O,
          {
            tone: "neutral",
            variant: "soft",
            size: "sm",
            icon: /* @__PURE__ */ t(
              "span",
              {
                "aria-hidden": "true",
                style: {
                  width: 8,
                  height: 8,
                  borderRadius: "var(--radius-full)",
                  background: e.accountColor,
                  display: "inline-block"
                }
              }
            ),
            children: e.accountLabel
          }
        ) }),
        /* @__PURE__ */ t(i, { ...a, style: { ...s, width: o.business }, children: /* @__PURE__ */ c(
          "span",
          {
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: "var(--space-2)",
              color: "var(--text-secondary)"
            },
            children: [
              e.business,
              e.crmSync ? /* @__PURE__ */ t(I, { status: e.status, size: "xs", children: l.status }) : null
            ]
          }
        ) }),
        /* @__PURE__ */ t(i, { ...a, style: { ...s, width: o.lastAction }, children: /* @__PURE__ */ t(
          "span",
          {
            title: e.lastAction,
            style: {
              display: "block",
              maxWidth: o.lastAction,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "var(--text-secondary)"
            },
            children: e.lastAction
          }
        ) }),
        /* @__PURE__ */ t(
          i,
          {
            ...a,
            style: {
              ...s,
              width: o.date,
              color: "var(--text-tertiary)",
              fontSize: "var(--text-2xs)"
            },
            children: /* @__PURE__ */ t("time", { dateTime: e.lastActivityAt, children: l.lastActivity })
          }
        ),
        /* @__PURE__ */ t(
          i,
          {
            ...a,
            style: { ...s, width: o.action },
            "data-ls-row-stop": !0,
            onClick: (r) => r.stopPropagation(),
            children: /* @__PURE__ */ t(
              P,
              {
                "aria-label": l.sendToCrm,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ t(A, { size: 14, "aria-hidden": "true" }),
                onClick: () => y?.()
              }
            )
          }
        )
      ]
    }
  );
});
T.displayName = "LeadRow";
export {
  T as L
};
//# sourceMappingURL=LeadRow-DE2Upw2C.js.map
